export enum DeviceType {
  WEBSITE_ORDERING = 'WEBSITE_ORDERING'
}
